import { useCallback, useMemo, useState } from 'react';
import { IKpiCompanyData } from '../AllCompaniesData';
import { selectedKpiCompaniesStateDCJ } from '../AllCompaniesStateJ';
import { useClearTemplateAssignments } from '../hooks/useClearTemplateAssignments';
import { useAllKpiCompaniesActions } from './useAllKpiCompaniesActions';
import { useAtomValue } from 'jotai';

export function useClearTemplatesModal() {
  const clearTemplateAssignments = useClearTemplateAssignments();
  const { selectedAction, resetUIState } = useAllKpiCompaniesActions();
  const selectedCompanies = useAtomValue(selectedKpiCompaniesStateDCJ);
  const [loading, setLoading] = useState(false);

  const isOpen = selectedAction === 'clearTemplates' && selectedCompanies.length > 0;

  const companiesWithTemplates = useMemo(
    () =>
      selectedCompanies.filter(
        (c) => ((c as IKpiCompanyData).templateUuids?.length ?? 0) > 0
      ) as IKpiCompanyData[],
    [selectedCompanies]
  );

  const handleClose = useCallback(() => {
    resetUIState();
  }, [resetUIState]);

  const handleConfirm = useCallback(async () => {
    if (companiesWithTemplates.length === 0) {
      return;
    }
    setLoading(true);
    try {
      await clearTemplateAssignments(companiesWithTemplates.map(({ id }) => id));
      handleClose();
    } finally {
      setLoading(false);
    }
  }, [companiesWithTemplates, clearTemplateAssignments, handleClose]);

  return {
    isOpen,
    loading,
    companiesWithTemplates,
    handleClose,
    handleConfirm,
  };
}
